import React, { useContext, useEffect, useState } from 'react'
import { ShopContext } from '../context/ShopContext'
import Title from './Title';
import ProductCard from './ProductCard';

const RelatedProducts = ({category,subCategory}) => {

    const {products,reviews} = useContext(ShopContext);
    const [related,setRelated] = useState([]);
      const getAverageRating = (productId) => {
    const productReviews = reviews.filter((review) => review.productId === productId);
    if (productReviews.length === 0) return 0;
    const sum = productReviews.reduce((acc, review) => acc + review.rating, 0);
    return sum / productReviews.length;
  };

  // Format price with currency
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
    }).format(price);
  };

    useEffect(()=>{
    
        if (products.length > 0) {
            let productsCopy = products.slice();

            productsCopy = productsCopy.filter((item)=> category === item.category);
            productsCopy = productsCopy.filter((item)=> subCategory === item.subCategory);

            setRelated(productsCopy.slice(0,5));
        }

    },[products])

  return (
    <div className='my-24'>
      <div className='text-center text-3xl py-3'>

        <Title text1={'RELATED'} text2={'PRODUCTS'} />

      </div>

      <div onClick={window.scrollTo(0,0)} className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 gap-y-6'>

        {
            related.map((product,index)=>(
                <ProductCard
                  key={product._id}
                  product={product}
                  formatPrice={formatPrice}
                  getAverageRating={getAverageRating}
                  reviews={reviews}
                />
            ))
        }

      </div>
    </div>
  )
}

export default RelatedProducts
